import React from "react";
import { memo } from "react";
import classNames from "classnames";
import cx from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/components/filterTagStyle.js";

function FilterTagInitiatives(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const {
    filtersList,
    filtersNames,
    filtersGroups,
    filter,
    items,
    mode,
    nameClickHandler,
    removeItemHandler,
    color,
    viewOnly,
    wrapperClass,
  } = props;

  if (items.length === 0) {
    return null;
  }

  // Safety check for filtersList
  if (!filtersList || !Array.isArray(filtersList)) {
    return null;
  }

  const categoryCallback =
    viewOnly || !nameClickHandler ? null : () => nameClickHandler(filter);

  const categoryTag = (
    <span
      className={cx({
        [classes.categoryTag]: true,
        ["cursorPointer"]: !viewOnly,
      })}
      onClick={categoryCallback}
    >
      {filtersNames &&
      filtersNames[filter] &&
      filtersNames[filter][i18n.language]
        ? filtersNames[filter][i18n.language]
        : filter}
    </span>
  );

  let itemsTags;
  // Calculate color index safely
  let colorIndex = 1; // default fallback
  try {
    if (filtersList && Array.isArray(filtersList)) {
      const filterIndex = filtersList.findIndex((f) => f === filter);
      colorIndex = filterIndex >= 0 ? (filterIndex % 12) + 1 : 1;
    }
  } catch (error) {
    colorIndex = 1;
  }

  const itemTagsClasses = classNames({
    [classes.itemTag]: true,
    [classes["color" + colorIndex]]: !color,
    [classes[color]]: color,
  });

  if (mode === "group") {
    itemsTags = (
      <span className={itemTagsClasses}>
        {filtersGroups &&
        filtersGroups[filter] &&
        filtersGroups[filter][items[0]] &&
        filtersGroups[filter][items[0]][i18n.language]
          ? filtersGroups[filter][items[0]][i18n.language]
          : items[0]}
        {!viewOnly && (
          <a onClick={() => removeItemHandler(filter, items[0])}></a>
        )}
      </span>
    );
  } else if (items.length <= 5) {
    // Simplified logic: just pass the item and filter, no complex indexing
    itemsTags = items.map((item, key) => (
      <span key={`${filter}-${item}-${key}`} className={itemTagsClasses}>
        {item === "" ? "● " + t("results.blank") + " ●" : item}
        {!viewOnly && <a onClick={() => removeItemHandler(filter, item)}></a>}
      </span>
    ));
  } else {
    itemsTags = (
      <span className={itemTagsClasses}>
        {items.length + " " + t("filter_tag.items_selected")}
        {!viewOnly && (
          <a onClick={() => removeItemHandler(filter, null, true)}></a>
        )}
      </span>
    );
  }

  return (
    <div className={wrapperClass || classes.categoryWrapper}>
      {categoryTag}
      {itemsTags}
    </div>
  );
}

FilterTagInitiatives.propTypes = {
  filtersList: PropTypes.arrayOf(PropTypes.string).isRequired,
  filtersNames: PropTypes.object.isRequired,
  filtersGroups: PropTypes.object,
  filter: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  mode: PropTypes.string.isRequired,
  nameClickHandler: PropTypes.func,
  removeItemHandler: PropTypes.func,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "client",
    "gray",
    "light",
  ]),
  viewOnly: PropTypes.bool,
  wrapperClass: PropTypes.string,
};

function areEqual(prevProps, nextProps) {
  return (
    prevProps.filter === nextProps.filter &&
    JSON.stringify(prevProps.items) === JSON.stringify(nextProps.items) &&
    prevProps.mode === nextProps.mode &&
    prevProps.color === nextProps.color &&
    prevProps.viewOnly === nextProps.viewOnly &&
    prevProps.removeItemHandler === nextProps.removeItemHandler
  );
}

export default memo(FilterTagInitiatives, areEqual);
